import * as yup from 'yup';

export const getCommerciauxFilterSchema = yup.object().shape({
  enabled: yup.string(),
  region: yup.string(),
  department: yup.string(),
});
